export const sharedMapConstants = {
  mapOptions: {
    gestureHandling: 'greedy',
    styles: null,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    fullscreenControl: false,
    zoom: 12,
    width: '100%',
    height: '100%',
    center: { lat: 4.570868, lng: -74.297333 },
    commonMarkerWidth: 36,
    commonMarkerHeight: 46,
    customMarkerWidth: 36,
    customMarkerHeight: 36,
    commonLabelX: 19,
    commonLabelY: 18,
    extraMarkerWidth: 42,
    extraMarkerHeight: 52,
    extraLabelX: 17.5,
    extraLabelY: 25,
    extraLabelColorActive: '#ffffff',
    markerUrl: 'assets/images/icons/mapMarkers/marker-',
    markerExtension: '.png',
    iconFontFamily: 'Mu Icon Font',
  },
};
